export const messages = {
    "small": {
        "linkTextS": "Student",
        "linkTextT": "Teacher",
    },
    "large": {
        "title": "20% Off For Teachers & College Students (US Only)",
        "subtitle": "We've done our homework and are offering A+ products, so you can stay comfortable in the classroom.",
        "subtitle2": "Discount available for US K-12 Teachers, College Students, College Faculty, and staff only.",
        "sheeridFaq": "SheerID FAQs",
    },
}
